/**
 * Tutorial guidato di Impostazioni > Storage.
 *
 * Un preparativo solo: il riquadro di Amazon S3, che il passo dedicato apre per mostrarne i campi.
 * `stopStorageSettingsTour` lo richiude a fine giro, e solo se ad aprirlo e' stato il tutorial.
 * L'interruttore non si tocca: salva subito (e prova lo storage).
 */
const SCOPE = '[data-tour-scope="setting-storage"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo provider, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopStorageSettingsTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createStorageSettingsTourSteps() {
	return [
		{
			body: 'Qui decidi dove finiscono foto e file del negozio. Se non fai niente restano sullo storage di AzSeller, come sempre: questa pagina serve solo a chi vuole tenerli nel proprio account.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Dove stanno i tuoi file',
		},
		{
			body: 'Un provider per riga. Per ora si collega Amazon S3 con CloudFront; Google Cloud Storage e Azure arriveranno più avanti. Attivando il tuo storage solo i file nuovi vanno lì: quelli già caricati restano dove sono e continuano a funzionare.',
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'I provider',
		},
		{
			body: 'Il più a inizio riga apre la configurazione: chiave di accesso dell’utente IAM, region e nome del bucket, e l’indirizzo della distribuzione CloudFront che serve le immagini.',
			before: stopStorageSettingsTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: 'Compila i campi e premi Conferma. La Secret Access Key non viene più mostrata dopo il salvataggio: lasciala vuota per tenere quella già salvata.',
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Le credenziali',
		},
		{
			body: 'Verifica connessione carica un file di prova nel bucket, lo rilegge dall’indirizzo pubblico e lo cancella. Lo stesso controllo parte quando accendi l’interruttore: se qualcosa non va, lo storage resta spento e ti dice cosa sistemare.',
			before: openFirst,
			key: 'check',
			placement: 'top',
			target: at('check'),
			timeout: 600,
			title: 'Provare prima di attivare',
		},
		{
			body: 'L’interruttore attiva il tuo storage. Spegnendolo i file nuovi tornano sullo storage di AzSeller; quelli caricati nel frattempo restano nel tuo bucket.',
			before: stopStorageSettingsTour,
			key: 'switch',
			placement: 'left',
			target: at('switch'),
			timeout: 400,
			title: 'Attivare',
		},
	];
}
